import Vue from "vue";

import "blueimp-canvas-to-blob";

import { sync } from "vuex-router-sync";

import "@/utils/proto";
import "@/vendor/MintComponents";
import "@/vendor/VueProtoExt";

import { less_init } from "@/utils/less";
less_init();

import App from "./App.vue";
import router from "./router";
import store from "./store";
import { i18n } from "./lang";
import {
  Icon,
  Collapse,
  CollapseItem,
  Popup,
  Overlay,
  CountDown,
  ActionSheet,
  Button,
  Tab,
  Tabs,
  Sticky,
  DropdownMenu,
  DropdownItem,
  Lazyload,
  Empty,
  RadioGroup,
  Radio,
  Calendar,
  Checkbox
} from "vant";
import { Image as VanImage } from "vant";

Vue.use(VanImage);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Overlay);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Sticky);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Lazyload);
Vue.use(Empty);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Button);
Vue.use(Calendar);
Vue.use(CountDown);
Vue.use(Checkbox);
Vue.use(ActionSheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
// import "@/utils/request";
// import VueLoaders from 'vue-loaders';
import VueVideoPlayer from "vue-video-player";

// Vue.use(VueLoaders);
Vue.use(VueVideoPlayer);

sync(store, router);

import "./errorLog";
import "./registerServiceWorker";

import * as directive from "./directive"; // global directive
import * as filters from "./filters"; // global filters

// register global utility directive.
Object.keys(directive).forEach(key => {
  Vue.use(directive[key]);
});

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

import "@/icons"; // icon

import "@/assets/css/css.less";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import "@/styles/index.scss"; // global css
import "@/assets/css/icon/iconfont.css";
import "@/assets/css/mint.css";
import "@/styles/theme.less";
import "vue-loaders/dist/vue-loaders.css";

Vue.config.productionTip = false;

function hanlleInitWatchman(productNumber) {
  return new Promise((resolve, reject) => {
    if (Vue.prototype.WmInstance) {
      resolve(Vue.prototype.WmInstance);
    } else {
      initWatchman({
        productNumber: productNumber,
        onload: function(instance) {
          resolve(instance);
          Vue.prototype.WmInstance = instance;
        },
        onerror: function(error) {
          reject(new Error());
        }
      });
    }
  });
}

Vue.prototype.$tex = function() {
  const args = Array.prototype.slice.apply(arguments);
  const text = args[0];
  const options = args[1] || {};
  if (store.getters.isInternational) {
    if (
      text === "元" ||
      text === "¥" ||
      text === "￥" ||
      text === "RMB" ||
      text === "人民币"
    ) {
      return store.getters.sysExchangeInfo.tcurIcon;
    }
    if (options.unit) {
      options.unit = store.getters.sysExchangeInfo.tcurIcon;
    }
  }
  return this.$t.apply(this, args);
};

Vue.prototype.goBack = () => {
  let routerCount = store.state.routerCount;
  if (routerCount > 1) {
    routerCount = routerCount - 2;
    store.commit("SET_ROUTER_COUNT", routerCount);
    router.back();
  } else {
    router.push("/home");
  }
};
Vue.prototype.initWatchman = hanlleInitWatchman;

export default new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App)
});
